import env from './env';
import bridge from 'libs/bridge';
// 鲁班新商详跳转小店打点 参考vue项目修改 第一版打点 使用很少没有进行使用promise化
interface LogV1Obj {
    tag?: string;
    label?: string;
    extra?: {};
}
interface EventObj {
    extJson?: any;
    ext_json?: any;
    labelName: string;
    eventName: string;
}

/**
 * 发送事件必须添加 EVENT_ORIGIN_FEATURE 字段
 * @param {*} data
 */
function addEventOriginFeature(data: any): void {
    // 待发送的事件对象必须存在，否则没有意义
    if (data) {
        data.extra = data.extra || {};
        // 在extra内部添加EVENT_ORIGIN_FEATURE属性
        // extra内部必须避免使用EVENT_ORIGIN_FEATURE
        // 否则会被覆盖
        data.extra.EVENT_ORIGIN_FEATURE = 'TEMAI';
    }
}

// jsbridge-sendlog上报日志  第一版日志上报埋点 暂时时只给鲁班用
export function jsbridgeSendLog(obj: LogV1Obj): void {
    if (!obj) return;
    const eventObj: EventObj = {
        eventName: obj.tag!,
        labelName: obj.label!
    };
    addEventOriginFeature(obj);
    eventObj[env.isDouYin ? 'extJson' : 'ext_json'] = obj.extra;
    bridge.call('sendLog', eventObj);
}
export const sendLogV1 = (
    { tag = 'views_product_item', label = 'order_submit_success', extra = {} }: LogV1Obj = {
        tag: 'views_product_item',
        label: 'order_submit_success',
        extra: {}
    }
) => {
    jsbridgeSendLog({ tag, label, extra });
};
